module.exports = __webpack_public_path__ + "static/media/Upload.8a3cae0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/JoinProfile/Upload.svg
// module id = 356
// module chunks = 0